module.exports = __webpack_public_path__ + "static/media/documents.999d0e5f.jpg";